import { render, staticRenderFns } from "./achievementsInfo.vue?vue&type=template&id=79aa3405&scoped=true&"
import script from "./achievementsInfo.vue?vue&type=script&lang=js&"
export * from "./achievementsInfo.vue?vue&type=script&lang=js&"
import style0 from "./achievementsInfo.vue?vue&type=style&index=0&id=79aa3405&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aa3405",
  null
  
)

export default component.exports